/**
 * Block: Promotional Content
 */

import $ from 'jquery';
import 'slick-carousel';

class PromotionalContent {
	constructor(el) {
		this.el = el;
		this.slickSlider = el.querySelector('.em-promotional-content__container');
	}

	init() {
		const { slickSlider } = this;

		$(slickSlider).slick({
			dots: false,
			infinite: true,
			fade: true,
			slidesToScroll: 1,
			slidesToShow: 1,
			speed: 500,
			arrows: true,
		});
	}
}

const promotionalContent = {
	init() {
		const promotionalContentBlock = document.querySelectorAll('.em-promotional-content');

		if (promotionalContentBlock.length) {
			promotionalContentBlock.forEach((block) => {
				const pc = new PromotionalContent(block);
				pc.init();
			});
		}
	},
};

promotionalContent.init();
